// import { Close } from "@mui/icons-material";
// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
// import {
//   Box,
//   Button,
//   ButtonBase,
//   Dialog,
//   DialogContent,
//   Grid,
//   IconButton,
//   InputAdornment,
//   MenuItem,
//   TextField,
//   Typography,
// } from "@mui/material";
// import React, { useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import nyscBg from "../../../assets/images/nyscright.png";
// import { useIsMobile } from "../../../components/hooks/useIsMobile";
// import { GlobalContext } from "../../../context";
// import { signInHandler, signupHandler } from "../../../context/actions/auth";
// import { fetchSignUpLocation } from "../../../utility";

// const campData = [
//   { state: "Abia", camp: "Umuahia Camp" },
//   { state: "Adamawa", camp: "Lifecamp, Yola" },
//   { state: "Akwa Ibom", camp: "Ikot Itie Udung Camp" },
//   { state: "Anambra", camp: "Mkpoko Camp, Umunze" },
//   { state: "Bauchi", camp: "Bauchi Camp" },
//   { state: "Bayelsa", camp: "Sagbama Camp" },
//   { state: "Benue", camp: "Gboko Camp" },
//   { state: "Borno", camp: "Maiduguri Camp" },
//   { state: "Cross River", camp: "Obubra Camp" },
//   { state: "Delta", camp: "Issele-Uku Camp" },
//   { state: "Ebonyi", camp: "Abakaliki Camp" },
//   { state: "Edo", camp: "Okada Camp" },
//   { state: "Ekiti", camp: "Ise-Orun Camp" },
//   { state: "Enugu", camp: "Awgu Camp" },
//   { state: "Gombe", camp: "Gombe Camp" },
//   { state: "Imo", camp: "Nekede Camp" },
//   { state: "Jigawa", camp: "Dutse Camp" },
//   { state: "Kaduna", camp: "Manchok Camp" },
//   { state: "Kano", camp: "Kano Camp" },
//   { state: "Kogi", camp: "Anyigba Camp" },
//   { state: "Kwara", camp: "Yikpata Camp" },
//   { state: "Lagos", camp: "Iyana-Ipaja Camp" },
//   { state: "Nasarawa", camp: "Keffi Camp" },
//   { state: "Niger", camp: "Paiko Camp" },
//   { state: "Ogun", camp: "Sagamu Camp" },
//   { state: "Ondo", camp: "Ikare Camp" },
//   { state: "Osun", camp: "Ede Camp" },
//   { state: "Oyo", camp: "Iseyin Camp" },
//   { state: "Plateau", camp: "Mangu Camp" },
//   { state: "Rivers", camp: "Nonwa Camp" },
//   { state: "Sokoto", camp: "Wammako Camp" },
//   { state: "Taraba", camp: "Jalingo Camp" },
//   { state: "Yobe", camp: "Damaturu Camp" },
//   { state: "Zamfara", camp: "Talata Mafara Camp" },
//   { state: "Federal Capital Territory (FCT)", camp: "Kubwa Camp" },
// ];

// const SignupDialog = ({ open, handleClose, apiUrl, onSubmit }) => {
//   const [type, setType] = useState("signup");
//   const navigate = useNavigate();
//   const [country, setCountry] = useState("");
//   const [region, setRegion] = useState("");
//   const [city, setCity] = useState("");
//   const [formData, setFormData] = useState({
//     firstname: "",
//     lastname: "",
//     camp: "", // Changed to represent state and camp together
//     email: "",
//     location: {
//       country: "",
//       region: "",
//       city: "",
//     },
//     user_type: "nysc",

//     telephone: "",
//     password: "",
//     country_code: "+234",
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const mobile = useIsMobile();
//   useEffect(() => {
//     fetchSignUpLocation().then((res) => {
//       setCountry(res?.country);
//       setRegion(res?.region);
//       setCity(res?.city);
//     });
//   }, []);

//   // Update location in formData when country, region, or city changes
//   useEffect(() => {
//     setFormData((prev) => ({
//       ...prev,
//       location: { country, region, city },
//     }));
//   }, [country, region, city]);

//   // Toggle password visibility
//   const handleClickShowPassword = () => setShowPassword(!showPassword);
//   const handleMouseDownPassword = (event) => event.preventDefault();

//   // Handle input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//   };
//   const { authDispatch } = useContext(GlobalContext);
//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     if (type === "signup") {
//       const response = await signupHandler(formData, authDispatch);
//       if (response) {
//         navigate("/vonverify");
//         onSubmit();
//       } else {
//         onSubmit();
//       }
//     } else {
//       const response = await signInHandler(
//         {
//           email: formData.email,
//           password: formData.password,
//         },
//         authDispatch
//       );
//       if (response) {
//         navigate("/");
//         onSubmit();
//       } else {
//         onSubmit();
//       }
//     }

//     setLoading(false);
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={handleClose}
//       maxWidth="md"
//       fullWidth
//       sx={{
//         '& .MuiDialog-paper': {
//           height: '90vh',
//           maxHeight: '90vh',
//         },
//       }}
//     >
//       <DialogContent sx={{
//         overflow: 'hidden',
//         display: 'flex',
//         flexDirection: 'column',
//         p: 0,
//         height: '100%'
//       }}>
//         <Box sx={{ overflowY: 'auto', flex: 1, p: 2 }}>
//           <div style={{ display: "flex", justifyContent: "flex-end" }}>
//             <ButtonBase onClick={handleClose} color="primary">
//               <Close style={{ color: "red" }} />
//             </ButtonBase>
//           </div>

//           <Grid container spacing={4} sx={{overflowY: 'auto', }} >
//             {/* Left Side: Signup Form */}
//             <Grid
//               item
//               xs={12}
//               md={6}
//               sx={{ display: "flex", alignItems: "center" }}
//             >
//               <Box
//                 sx={{
//                   p: { sm: 1, md: 4 },
//                   backgroundColor: mobile ? "" : "#f9f9f9",
//                   borderRadius: 2,
//                   width: "100%",
//                 }}
//               >
//                 <Typography variant="h4" fontWeight="bold" gutterBottom>
//                   {type === "signup" ? "Sign up E1X" : "Sign In E1X"}
//                 </Typography>
//                 {type === "signup" ? (
//                   <Typography variant="body2" gutterBottom>
//                     Already have an account?{" "}
//                     <ButtonBase
//                       style={{
//                         color: "#d15242",
//                       }}
//                       onClick={() => {
//                         setType("login");
//                       }}
//                     >
//                       Login
//                     </ButtonBase>
//                   </Typography>
//                 ) : (
//                   <Typography variant="body2" gutterBottom>
//                     Don't have an account?{" "}
//                     <ButtonBase
//                       style={{
//                         color: "#d15242",
//                       }}
//                       onClick={() => {
//                         setType("signup");
//                       }}
//                     >
//                       Sign Up
//                     </ButtonBase>
//                   </Typography>
//                 )}

//                 {type === "signup" ? (
//                   <Box
//                     component="form"
//                     sx={{ mt: 1 }}
//                     onSubmit={handleSubmit}
//                     style={{
//                       transition: "ease-in-out 2s",
                      
//                     }}
//                   >
//                     <div>
//                       <TextField
//                         fullWidth
//                         label="First Name"
//                         variant="outlined"
//                         margin="normal"
//                         name="firstname"
//                         value={formData.firstname}
//                         onChange={handleChange}
//                         required
//                       />
//                       <TextField
//                         fullWidth
//                         label="Last Name"
//                         variant="outlined"
//                         margin="normal"
//                         name="lastname"
//                         value={formData.lastname}
//                         onChange={handleChange}
//                         required
//                       />
//                     </div>
//                     <TextField
//                       fullWidth
//                       select
//                       variant="outlined"
//                       margin="normal"
//                       label="Camp"
//                       name="camp" // Fixed the name to use 'camp'
//                       value={formData.camp}
//                       onChange={handleChange}
//                       required
//                     >
//                       <MenuItem value="">
//                         <em>Select State and Camp</em>
//                       </MenuItem>
//                       {campData.map((item, index) => (
//                         <MenuItem
//                           key={index}
//                           value={`${item.state} - ${item.camp}`}
//                         >
//                           {`${item.state} - ${item.camp}`}
//                         </MenuItem>
//                       ))}
//                     </TextField>
//                     <TextField
//                       fullWidth
//                       label="Email Address"
//                       variant="outlined"
//                       margin="normal"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       required
//                     />
//                     <TextField
//                       fullWidth
//                       label="Telephone"
//                       variant="outlined"
//                       margin="normal"
//                       name="telephone"
//                       value={formData.telephone}
//                       onChange={handleChange}
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start">+234</InputAdornment>
//                         ),
//                       }}
//                       required
//                     />
//                     <TextField
//                       fullWidth
//                       label="Password"
//                       variant="outlined"
//                       margin="normal"
//                       name="password"
//                       type={showPassword ? "text" : "password"}
//                       value={formData.password}
//                       onChange={handleChange}
//                       required
//                       InputProps={{
//                         endAdornment: (
//                           <InputAdornment position="end">
//                             <IconButton
//                               onClick={handleClickShowPassword}
//                               onMouseDown={handleMouseDownPassword}
//                               edge="end"
//                             >
//                               {showPassword ? <VisibilityOff /> : <Visibility />}
//                             </IconButton>
//                           </InputAdornment>
//                         ),
//                       }}
//                     />

//                     <Button
//                       fullWidth
//                       type="submit"
//                       variant="contained"
//                       color="primary"
//                       size="large"
//                       disabled={loading}
//                       sx={{
//                         mt: 3,
//                         backgroundColor: "#d15424",
//                         "&:hover": { backgroundColor: "#d15424" },
//                       }}
//                     >
//                       {loading ? "Creating Account..." : "Create Account"}
//                     </Button>
//                   </Box>
//                 ) : (
//                   <Box
//                     component="form"
//                     sx={{ mt: 1 }}
//                     onSubmit={handleSubmit}
//                     style={{
//                       transition: "ease-in-out 2s",
//                     }}
//                   >
//                     <TextField
//                       fullWidth
//                       label="Email Address"
//                       variant="outlined"
//                       margin="normal"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       required
//                     />

//                     <TextField
//                       fullWidth
//                       label="Password"
//                       variant="outlined"
//                       margin="normal"
//                       name="password"
//                       type={showPassword ? "text" : "password"}
//                       value={formData.password}
//                       onChange={handleChange}
//                       required
//                       InputProps={{
//                         endAdornment: (
//                           <InputAdornment position="end">
//                             <IconButton
//                               onClick={handleClickShowPassword}
//                               onMouseDown={handleMouseDownPassword}
//                               edge="end"
//                             >
//                               {showPassword ? <VisibilityOff /> : <Visibility />}
//                             </IconButton>
//                           </InputAdornment>
//                         ),
//                       }}
//                     />

//                     <Button
//                       fullWidth
//                       type="submit"
//                       variant="contained"
//                       color="primary"
//                       size="large"
//                       disabled={loading}
//                       sx={{
//                         mt: 3,
//                         backgroundColor: "#d15424",
//                         "&:hover": { backgroundColor: "#d15424" },
//                       }}
//                     >
//                       {loading ? "Loading..." : "Login"}
//                     </Button>
//                   </Box>
//                 )}
//               </Box>
//             </Grid>

//             {!mobile && (
//               <Grid item xs={12} md={6} sx={{ overflow: 'hidden' }}>
//                 <img
//                   src={nyscBg}
//                   alt="illustration"
//                   style={{
//                     width: '100%',
//                     height: '100%',
//                     objectFit: 'cover'
//                   }}
//                 />
//               </Grid>
//             )}
//           </Grid>
//         </Box>
//       </DialogContent>
//     </Dialog>
//   );
// };

// export default SignupDialog;
import { Close, Visibility, VisibilityOff } from "@mui/icons-material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import nyscBg from "../../../assets/images/nyscright.png";
import { useIsMobile } from "../../../components/hooks/useIsMobile";
import { GlobalContext } from "../../../context";
import { signInHandler, signupHandler } from "../../../context/actions/auth";
import { fetchSignUpLocation } from "../../../utility";

const campData = [
  { state: "Abia", camp: "Umuahia Camp" },
  { state: "Adamawa", camp: "Lifecamp, Yola" },
  { state: "Akwa Ibom", camp: "Ikot Itie Udung Camp" },
  { state: "Anambra", camp: "Mkpoko Camp, Umunze" },
  { state: "Bauchi", camp: "Bauchi Camp" },
  { state: "Bayelsa", camp: "Sagbama Camp" },
  { state: "Benue", camp: "Gboko Camp" },
  { state: "Borno", camp: "Maiduguri Camp" },
  { state: "Cross River", camp: "Obubra Camp" },
  { state: "Delta", camp: "Issele-Uku Camp" },
  { state: "Ebonyi", camp: "Abakaliki Camp" },
  { state: "Edo", camp: "Okada Camp" },
  { state: "Ekiti", camp: "Ise-Orun Camp" },
  { state: "Enugu", camp: "Awgu Camp" },
  { state: "Gombe", camp: "Gombe Camp" },
  { state: "Imo", camp: "Nekede Camp" },
  { state: "Jigawa", camp: "Dutse Camp" },
  { state: "Kaduna", camp: "Manchok Camp" },
  { state: "Kano", camp: "Kano Camp" },
  { state: "Kogi", camp: "Anyigba Camp" },
  { state: "Kwara", camp: "Yikpata Camp" },
  { state: "Lagos", camp: "Iyana-Ipaja Camp" },
  { state: "Nasarawa", camp: "Keffi Camp" },
  { state: "Niger", camp: "Paiko Camp" },
  { state: "Ogun", camp: "Sagamu Camp" },
  { state: "Ondo", camp: "Ikare Camp" },
  { state: "Osun", camp: "Ede Camp" },
  { state: "Oyo", camp: "Iseyin Camp" },
  { state: "Plateau", camp: "Mangu Camp" },
  { state: "Rivers", camp: "Nonwa Camp" },
  { state: "Sokoto", camp: "Wammako Camp" },
  { state: "Taraba", camp: "Jalingo Camp" },
  { state: "Yobe", camp: "Damaturu Camp" },
  { state: "Zamfara", camp: "Talata Mafara Camp" },
  { state: "Federal Capital Territory (FCT)", camp: "Kubwa Camp" },
];

const SignupDialog = ({ open, handleClose, apiUrl, onSubmit }) => {
  const [type, setType] = useState("signup");
  const navigate = useNavigate();
  const [country, setCountry] = useState("");
  const [region, setRegion] = useState("");
  const [city, setCity] = useState("");
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    camp: "",
    email: "",
    location: {
      country: "",
      region: "",
      city: "",
    },
    user_type: "nysc",
    telephone: "",
    password: "",
    country_code: "+234",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const mobile = useIsMobile();

  useEffect(() => {
    fetchSignUpLocation().then((res) => {
      setCountry(res?.country);
      setRegion(res?.region);
      setCity(res?.city);
    });
  }, []);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      location: { country, region, city },
    }));
  }, [country, region, city]);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (event) => event.preventDefault();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const { authDispatch } = useContext(GlobalContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (type === "signup") {
      const response = await signupHandler(formData, authDispatch);
      if (response) {
        navigate("/vonverify");
        onSubmit();
      } else {
        onSubmit();
      }
    } else {
      const response = await signInHandler(
        {
          email: formData.email,
          password: formData.password,
        },
        authDispatch
      );
      if (response) {
        navigate("/");
        onSubmit();
      } else {
        onSubmit();
      }
    }

    setLoading(false);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 md:pt-10 md:px-10 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full h-[90vh] max-h-[90vh]">
          <div className="bg-white h-full flex flex-col">
            <div className="overflow-y-auto flex-1 p-4 md:p-10">
              <div className="flex justify-end">
                <button onClick={handleClose} className="text-red-500">
                  <Close />
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 h-full overflow-y-auto">
                {/* Left Side: Signup Form */}
                <div className="flex items-center">
                  <div className={`p-4 md:p-8 ${!mobile ? "bg-gray-50" : ""} rounded-lg w-full`}>
                    <h4 className="text-2xl font-bold mb-4">
                      {type === "signup" ? "Sign up E1X" : "Sign In E1X"}
                    </h4>
                    {type === "signup" ? (
                      <p className="mb-4">
                        Already have an account?{" "}
                        <button
                          className="text-[#d15242]"
                          onClick={() => setType("login")}
                        >
                          Login
                        </button>
                      </p>
                    ) : (
                      <p className="mb-4">
                        Don't have an account?{" "}
                        <button
                          className="text-[#d15242]"
                          onClick={() => setType("signup")}
                        >
                          Sign Up
                        </button>
                      </p>
                    )}

                    {type === "signup" ? (
                      <form onSubmit={handleSubmit} className="mt-4">
                        <div>
                          <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                            <input
                              type="text"
                              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                              name="firstname"
                              value={formData.firstname}
                              onChange={handleChange}
                              required
                            />
                          </div>
                          <div className="mb-4">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                            <input
                              type="text"
                              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                              name="lastname"
                              value={formData.lastname}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Camp</label>
                          <select
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                            name="camp"
                            value={formData.camp}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select State and Camp</option>
                            {campData.map((item, index) => (
                              <option
                                key={index}
                                value={`${item.state} - ${item.camp}`}
                              >
                                {`${item.state} - ${item.camp}`}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                          <input
                            type="email"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Telephone</label>
                          <div className="relative rounded-md shadow-sm">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                              <span className="text-gray-500">+234</span>
                            </div>
                            <input
                              type="tel"
                              className="block w-full pl-12 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                              name="telephone"
                              value={formData.telephone}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                          <div className="relative rounded-md shadow-sm">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                              name="password"
                              value={formData.password}
                              onChange={handleChange}
                              required
                            />
                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                              <button
                                type="button"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                className="text-gray-500 hover:text-gray-700"
                              >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </button>
                            </div>
                          </div>
                        </div>

                        <button
                          type="submit"
                          disabled={loading}
                          className={`w-full mt-6 py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#d15424] hover:bg-[#d15424] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
                        >
                          {loading ? "Creating Account..." : "Create Account"}
                        </button>
                      </form>
                    ) : (
                      <form onSubmit={handleSubmit} className="mt-4">
                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                          <input
                            type="email"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="mb-4">
                          <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                          <div className="relative rounded-md shadow-sm">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
                              name="password"
                              value={formData.password}
                              onChange={handleChange}
                              required
                            />
                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                              <button
                                type="button"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                className="text-gray-500 hover:text-gray-700"
                              >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </button>
                            </div>
                          </div>
                        </div>

                        <button
                          type="submit"
                          disabled={loading}
                          className={`w-full mt-6 py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#d15424] hover:bg-[#d15424] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
                        >
                          {loading ? "Loading..." : "Login"}
                        </button>
                      </form>
                    )}
                  </div>
                </div>

                {!mobile && (
                  <div className="overflow-hidden">
                    <img
                      src={nyscBg}
                      alt="illustration"
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupDialog;